// @mui material components
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "devComponents/Navbars/PublicNavbar";

// Sections
import Contact from "./JobApplication";

// Videos
import bgVideo1 from "assets/background4.mp4";
import bgVideo2 from "assets/background4.mp4";

function index() {
  const getBackgroundVideo = () => {
    return Math.random() < 0.5 ? bgVideo1 : bgVideo2;
  };

  return (
    <MKBox data-ring="light">
      {/* Video Background + Navbar */}
      <MKBox
        position="relative"
        minHeight="30rem"
        width="100%"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        overflow="hidden"
      >
        {/* Video Element */}
        <video
          src={getBackgroundVideo()}
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -2,
          }}
        />
        {/* Black overlay */}
        <MKBox
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)", // adjust opacity here
            zIndex: -1,
          }}
        />

        <DefaultNavbar sx={{ zIndex: 1 }} />
      </MKBox>

      {/* Card overlapping video */}
      <Card
        sx={{
          background: "linear-gradient(145deg, #ffff 0%, #fafafa 100%)",
          color: "white",
          maxWidth: "100%",
          mx: "auto",
          mt: -5, // overlap with video
          px: { xs: 2, md: 4 },
          py: { xs: 4, md: 6 },
          borderRadius: "1rem",
          boxShadow: 6,
        }}
      >
        <Container>
          <Grid container justifyContent="center" spacing={2}>
            <Grid item xs={12} lg={10}>
              <MKTypography
                variant="h2"
                color="#eee"
                textAlign="center"
                mb={1}
                x
                sx={({ breakpoints, typography: { size } }) => ({
                  fontWeight: "500",
                  [breakpoints.down("md")]: {
                    fontSize: size["2xl"],
                  },
                })}
              >
                Careers at The DevHouse
              </MKTypography>

              <MKTypography
                variant="body2"
                textAlign="center"
                px={{ xs: 3, lg: 6 }}
                mt={2}
              >
                Here at The DevHouse, we are always looking for talented people
                to join our team! If you are interested in joining our team,
                please fill out the form below.
              </MKTypography>
            </Grid>
          </Grid>

          <Contact />
        </Container>
      </Card>
    </MKBox>
  );
}

export default index;
